import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { CSSProperties, ComponentProps } from "react";

import emailSent from "./lotties/emailSent.lottie";
import error404 from "./lotties/error404.lottie";
import notFound from "./lotties/notFound.lottie";
import script from "./lotties/script.lottie";
import tumbleweed from "./lotties/tumbleweed.lottie";

const modules = {
  notFound,
  emailSent,
  tumbleweed,
  error404,
  script,
};

type Props = {
  lottie: keyof typeof modules;
  style?: CSSProperties;
  mode?: ComponentProps<typeof DotLottieReact>["mode"];
};

export const Lottie = ({ lottie, style, mode = "bounce" }: Props) => {
  return (
    <DotLottieReact
      src={modules[lottie]}
      loop
      autoplay
      mode={mode}
      style={style}
    />
  );
};
